document.querySelectorAll<HTMLFormElement>('.pc-form').forEach(form => {
	const action = form.getAttribute('action')!
	const method = form.getAttribute('method')!

	const successMessage = form.dataset.success
	const errorMessage = form.dataset.error

	form.addEventListener('submit', async e => {
		e.preventDefault()
		form.classList.add('disabled')

		const submitBtn = form.querySelector<HTMLInputElement>(
			'input[type="submit"]'
		)!
		submitBtn.value = 'Submitting...'

		const statusOutput = form.querySelector<HTMLOutputElement>('.status')!

		const body = new FormData(form)
		const res = await fetch(action, {
			method,
			headers: {
				Accept: 'application/json',
			},
			body,
		})
		const { success, data } = await res.json()

		if (success) {
			submitBtn.value = 'Submitted'
			submitBtn.disabled = true
			statusOutput.classList.add('success')
			statusOutput.value =
				data?.message ||
				successMessage ||
				'Thank you! Your message has been sent and we will be in touch with you soon.'
		} else {
			submitBtn.value = 'Submit'
			form.classList.remove('disabled')
			statusOutput.classList.add('failure')
			statusOutput.value =
				data?.message ||
				errorMessage ||
				'There was a problem submitting your form. Please try again, or contact us at info@magauctions.com for assistance.'
		}
	})
})
